'use strict';

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function () {

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    var paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach(function (e) {
        return e.innerHTML.trim() === '' && e.parentNode.removeChild(e);
    });

    $('.sym-slides, .benefits-slide-images, .benefits-slide-copy').slick();

    $('#frmContact_yes-signup-form, #formRFP_yes-signup-form').addClass("required");
})();